import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BusinessPage = lazy(() => import('../pages/about/business/page'));
const BrandPage = lazy(() => import('../pages/about/brand/page'));
const SecurityPage = lazy(() => import('../pages/security/page'));
const IndustryPage = lazy(() => import('../pages/industry/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const NewsListPage = lazy(() => import('../pages/news-list/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/about/business',
    element: <BusinessPage />,
  },
  {
    path: '/about/brand',
    element: <BrandPage />,
  },
  {
    path: '/security',
    element: <SecurityPage />,
  },
  {
    path: '/industry',
    element: <IndustryPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news-list',
    element: <NewsListPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
